import { format } from 'date-fns';
import { LoginPeriod } from '@/features/superAdmin/features/dashboard/types/super-admin-dashboard-dto';

const getChartStep = (total: number) => {
    if (total <= 0) return 1;

    const target = total / 10;
    const magnitude = Math.pow(10, Math.floor(Math.log10(target)));
    const normalized = target / magnitude;
    const nice = normalized >= 5 ? 5 : normalized >= 2 ? 2 : 1;

    return nice * magnitude;
};

const formatChartPeriod = (date: string, period: LoginPeriod) => {
    const formatedDate = typeof date === 'string' ? new Date(date) : date;

    switch (period) {
        case LoginPeriod.Daily:
            return format(formatedDate, 'dd LLL yy');
        case LoginPeriod.Weekly:
            return format(formatedDate, "'W'I yyyy");
        case LoginPeriod.Monthly:
            return format(formatedDate, 'LLL yy');
        case LoginPeriod.Quarterly:
            return format(formatedDate, 'QQQ yyyy');
        case LoginPeriod.Yearly:
            return format(formatedDate, 'yyyy');
    }
};

const getChartMaxDomainValue = (data: { value: number }[], step: number) => {
    const maxValue = Math.max(...data.map((item) => item.value));
    return Math.ceil(maxValue / step) * step;
};

const getNiceMaxValue = (max: number) => {
    if (max === 0) return 10;
    const exponent = Math.floor(Math.log10(max));
    const factor = Math.pow(10, exponent);
    return Math.ceil(max / factor) * factor;
};

export const ChartHelper = {
    getChartStep,
    formatChartPeriod,
    getChartMaxDomainValue,
    getNiceMaxValue,
};
